define(
    'views/breadcrumbs.view',[
        'loader',
        'config',
        'helper',
        'sandbox',

        'text!templates/breadcrumbs.html'
    ],
    function(Loader, Config, Helper, Sandbox, breadcrumbsTemplate)
    {
        var $ = Loader.$;
        var _ = Loader._;

        var BreadcrumbsView = Loader.Backbone.View.extend(
            {

                initialize: function()
                {
                    var _this = this;
                    _.bindAll(this, 'render');

                    this.model.get('breadcrumbs').bind('update', function(){
                        _this.render();
                    });


                },

                render: function(global)
                {
                    if (global) return this;

                    var compiledTemplate = _.template(
                        breadcrumbsTemplate,
                        {
                            model: this.model.toJSON()
                        }
                    );

                    this.$el.html(compiledTemplate);

                    return this;
                }
            });

        return {
            initialize: function(model)
            {
                return new BreadcrumbsView({
                    el: $("#pun-crumbs1, #pun-crumbs2"),
                    model: model
                })
            }
        }
    }
);
